var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorld = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  stroke: "currentColor",
  strokeWidth: 1.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.2,
  d: "M8 1v14M1 8h14M8 1C5.5 1 3.5 4.134 3.5 8s2 7 4.5 7 4.5-3.134 4.5-7-2-7-4.5-7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.2,
  d: "M2.5 4.5c1.5 0 3 1 5.5 1s4-1 5.5-1m-11 7c1.5 0 3-1 5.5-1s4 1 5.5 1"
})));
export default SvgWorld;